<template>
  <span class="time-ago f-s-10">{{ prefixText }} {{ timeAgoText }}</span>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TimeAgo',
  props: {
    fromDate: {
      type: Date,
      required: true
    },
    prefixText: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      timeAgoText: '',
      timeAgoInterval: null
    };
  },
  watch: {
    fromDate() {
      this.setTimeAgoText();
      this.clearTimeAgoInterval();
      this.setTimeAgoInterval();
    }
  },
  created: function () {
    this.setTimeAgoText();
    this.setTimeAgoInterval();
  },
  beforeDestroy() {
    this.clearTimeAgoInterval();
  },
  methods: {
    setTimeAgoInterval() {
      this.clearTimeAgoInterval();
      this.timeAgoInterval = setInterval(this.setTimeAgoText.bind(this), 30 * 1000);
    },
    setTimeAgoText() {
      this.timeAgoText = moment(this.fromDate).fromNow();
    },
    clearTimeAgoInterval() {
      try {
        clearInterval(this.timeAgoInterval);
      } catch (e) {
        //
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/../app/styles/_vendors";

.time-ago {
  display: inline-block;
  width: 22ch;
  text-align: right;
  @include text-overflow();
}

</style>